import React from 'react';
import { Helmet } from 'react-helmet';
import Contact from '../components/contact/contact';
import ContactForm from '../components/contact/contact-form/contact-form';
import PageBanner from '../components/page-banner/page-banner.component';

const ContactPage: React.FC = () => {
  return (
    <>
      <Helmet title="Contact" />
      <PageBanner
        pageTitle="Contact"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Contact"
      />
      <Contact />
      <ContactForm />
    </>
  );
};

export default ContactPage;
